exports = module.exports = require("../../../node_modules/@zxcabs/rtl-css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".fa-bounce{display:inline-block;position:relative;animation:bounce .6s infinite linear}@keyframes bounce{0%{top:0}50%{top:-.2em}70%{top:-.3em}to{top:0}}", ""]);

// exports
